import {keyBy} from 'lodash';

export default function initRussiaHeatMap(stat) {
    let maxValue = 0;
    const data = stat.map(({name, hc_key: code, count: value}) => {
        if (parseInt(value, 10) > maxValue) {
            maxValue = parseInt(value, 10);
        }
        return {
            name,
            code,
            value,
        };
    });
    const relationRegionCodeWithName = keyBy(data, 'code');
    let mapData = getMapData();
    mapData = mapData.map((region) => {
        const name = relationRegionCodeWithName?.[region.id]?.name;
        return {
            ...region,
            name,
        };
    });

    return Highcharts.mapChart('heatMapPresenceRussiaInRanking', {
        mapNavigation: {
            enabled: true,
            buttonOptions: {
                verticalAlign: 'bottom',
            },
        },
        title: {
            text: '',
        },
        colorAxis: {
            type: 'linear',
            min: 0,
            max: maxValue,
            stops: [[0, '#F1EEF6'], [0.20, '#6842ff'], [1, '#6500ec']],
        },

        series: [{
            data,
            mapData,
            joinBy: ['hc-key', 'code'],
            name: 'Количество образовательных организаций в рейтинге',
            borderWidth: 0.5,
        }],
        credits: {
            enabled: false,
        },
    });
}

function getMapData() {
    let mapData = Highcharts.geojson(Highcharts.maps['countries/ru/custom/ru-all-disputed']);
    mapData = mapData.map((region) => {
        return {
            ...region,
            id: region.properties['hc-key'],
        };
    });
    return mapData;
}
